const formatLocalDate = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const getInventoryStartDateDefault = (today = new Date()) => {
  const startDate = new Date(today.getTime())
  startDate.setDate(startDate.getDate() - 5)
  return formatLocalDate(startDate)
}

export const resolveInventoryStartDate = (savedState, today = new Date()) => {
  if (
    savedState &&
    Object.prototype.hasOwnProperty.call(savedState, 'inventoryStartDate')
  ) {
    return savedState.inventoryStartDate ?? ''
  }

  return getInventoryStartDateDefault(today)
}
